module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/n3GV6H/tc-custom/9781460344804.jpg?1718183454298",
      "alt": "This image is the cover for the book Bride for a Knight, The Knights' Prizes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bride for a Knight, The Knights' Prizes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("The promise of the bedchamber")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _vm._v("After glimpsing a softer side to the stern Sir Roland of Dunborough, Mavis of DeLac is filled with hope for their arranged marriage. So when the wedding night explodes with an exquisite passion, she dares to dream that their newfound bliss will last forever. "), _c('br'), _c('br'), _vm._v("But the following morning, convinced he could never make this beautiful woman truly happy, Roland becomes cold and aloof once again. And as the newlyweds journey across England to protect Roland's birthright, it's up to Mavis to prove him wrongand unlock the compassion this noble knight has buried deep inside. "), _c('br'), _c('br'), _vm._v("\"Moore. Moore. Moore. Fans will love her newest medieval romance.\" "), _c('i', [_vm._v("RT Book Reviews")]), _vm._v(" on "), _c('i', [_vm._v("Castle of the Wolf")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Moore actually began her writing career at the age of eight, when she and a friend would make up stories together. She also loved to read and many years later graduated with a Bachelor of Arts degree in English Literature. After reading a romance by Kathleen Woodiwiss, Margaret took a course in popular fiction writing and through that, found Romance Writers of America. Three years later, in 1991, she sold her first historical romance. And the rest, as they say, is history!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0